import styled from 'styled-components';

const DivCategoryHome = styled.div`
  margin-bottom: 50px;
`;

export default DivCategoryHome;
